<template>
	<div>
		<navpage
			ref="navPage"
			:middle="true"
			:displayDates="true"
			pagename="AnimatedChartPage"
			:displayFilters="false"
			:updateParameters="true"
			:displayAllButton="false"
		></navpage>

		<div id="content-page">
			<div class="row dynvibeRow">
				<dynamicevolution axios="barRaceChartMastertags"></dynamicevolution>
			</div>
			<div class="row dynvibeRow">
				<barchartrace axios="barRaceChartMastertags"></barchartrace>
			</div>
			<div class="row dynvibeRow">
				<barchartrace axios="barRaceChartMentions"></barchartrace>
			</div>
			<div class="row dynvibeRow">
				<barchartrace axios="barRaceChartKeywords"></barchartrace>
			</div>
			<div class="row dynvibeRow">
				<dynamic></dynamic>
			</div>
			<div class="row dynvibeRow">
				<spider></spider>
			</div>
			<div class="row dynvibeRow">
				<!--<sankey></sankey>-->
			</div>
			<div class="row dynvibeRow">
				<animatedwordcloud></animatedwordcloud>
			</div>
		</div>
	</div>
</template>

<script>
import navpage from "@/components/globalVue/Nav.vue";
import barchartrace from "@/components/vueCharts/DynvibeBarChartRace.vue";
import dynamic from "@/components/vueCharts/DynvibeDynamicNew.vue";
import dynamicevolution from "@/components/vueCharts/DynvibeDynamicEvolution.vue";
import spider from "@/components/vueCharts/DynvibeSpiderWeb.vue";
//import sankey from "@/components/vueCharts/DynvibeSankey.vue";
import animatedwordcloud from "@/components/vueCharts/DynvibeAnimatedWordCloud.vue";

export default {
	name: "AnimatedChartPage",
	props: {},
	data() {
		return {
			// date: { gte: "", lte: "" },
		};
	},
	created() {},
	components: {
		navpage: navpage,
		barchartrace: barchartrace,
		dynamic: dynamic,
		dynamicevolution: dynamicevolution,
		spider: spider,
		//sankey: sankey,
		animatedwordcloud: animatedwordcloud,
	},
	methods: {
		/*trendFilters(val) {
			this.panel = val.panel;
			this.segment = val.segment;
			this.date = val.date;
			this.country = val.country;
			this.category = val.category;
			this.subcategory = val.subcategory;
			this.mastertag = val.mastertag;
			if (this.date.gte !== "") {
				this.showOtherCharts = true;
			} else {
				this.showOtherCharts = false;
			}
		},*/
	},
};
</script>

<style scoped></style>
